export const HYPERDX_API_KEY = process.env.NEXT_PUBLIC_HYPERDX_API_KEY;
